<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}
// 日本語化
import ja from "vee-validate/dist/locale/ja";
localize("ja", ja);

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      search_game_id: "", // 検索用のGame ID
      search_school_code: "", // 検索用の学校コード
      search_type: null, // 検索用の分類
      type: "", // 追加・編集用の分類
      name: "", // 追加・編集用の氏名
      contact: "", // 追加・編集用の連絡先
      typeList: [
        { value: null, text: "" },
        { value: 1, text: "顧問（男子）" },
        { value: 2, text: "顧問（女子）" },
        { value: 3, text: "コーチ（男子）" },
        { value: 4, text: "コーチ（女子）" },
      ],
      game_id: "", // 追加・編集用のGame ID
      school_code: "", // 追加・編集用の学校コード
      tableData: [],
      title: "顧問・コーチ", // タイトルを修正
      items: [
        {
          text: "Staff",
          href: "/",
        },
        {
          text: "顧問・コーチ",
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      id: null,
      errors: [],
      selectAll: false,
      filterItems: [],
      filter: null,
      filterOn: ["type_name", "school_code", "school_name", "name", "contact"],
      fields: [
        {
          key: "checkbox",
          label: "",
          sortable: false,
        },
        {
          key: "type_name",
          label: "分類",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "school_code",
          label: "学校コード",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "school_name",
          label: "学校名",
          sortable: true,
          tdClass: "minWidth150",
        },
        {
          key: "name",
          label: "氏名",
          sortable: false,
          tdClass: "minWidth300",
        },
        {
          key: "contact",
          label: "連絡先",
          sortable: true,
          tdClass: "minWidth300",
        },
        { key: "actions", label: "", sortable: false, tdClass: "minWidth100" },
      ],
      loading: false,
      mode: "list",
      games: [], // ゲーム情報一覧を格納
      schoolList: [], // 学校一覧を格納
      staff: [], // スタッフ一覧を格納
      staffMasters: [], // StaffMaster一覧を格納
    };
  },
  mounted() {
    // VuexからGameIdを取得
    this.search_game_id = this.$store.state.gameId;

    let roles = this.$store.getters.roles;
    if (roles == "admin") {
      this.getUser("admin");
    } else if (roles == "user") {
      this.getUser("user");
      this.search_school_code = this.$store.getters.schoolCode;
    } else {
      window.location.href = "/";
      return;
    }
    this.searchItems();
  },
  computed: {
    // filteredStaff: 入力された学校コードでスタッフを絞り込む
    filteredStaff() {
      if (!this.school_code) {
        // 学校コードが未入力の場合、すべてのスタッフを返す
        return this.staff;
      }
      // 学校コードで絞り込む
      return this.staff.filter(member => member.school_code === this.school_code);
    },
    displayedFields() {
      return this.fields; // 通常のfieldsを表示
    },
    rows() {
      return this.filterItems.length;
    },
  },
  methods: {
    // 検索
    searchItems() {
      this.loading = true;
      axios
        .get("/api/staff", {
          params: {
            game_id: this.search_game_id,
            school_code: this.search_school_code || null, // 空白の場合はnullを送信
            type: this.search_type || null, // 顧問またはコーチのタイプ
          },
        })
        .then((response) => {
          this.loading = false;

          // スタッフ一覧データを設定
          this.tableData = response.data.staff.map((item) => {
            let typeName = "";
            switch (Number(item.type)) {
              case 1:
                typeName = "顧問（男子）";
                break;
              case 2:
                typeName = "顧問（女子）";
                break;
              case 3:
                typeName = "コーチ（男子）";
                break;
              case 4:
                typeName = "コーチ（女子）";
                break;
              default:
                typeName = "";
            }
            return {
              ...item,
              type_name: typeName,
            };
          });

          // Gameデータを設定
          this.games = [
            { value: "", text: "" }, // 空白の選択肢を追加
            ...response.data.games.map((game) => {
              return {
                value: game.id,
                text: game.name,
              };
            }),
          ];

          // Schoolデータを設定
          this.schoolList = [
            { value: "", text: "" }, // 空白の選択肢を追加
            ...response.data.schools.map((school) => {
              return {
                value: school.school_code,
                text: `${school.school_code} : ${school.school_name}`,
              };
            }),
          ];

          // StaffMasterデータを設定
          this.staffMasters = response.data.staffMasters.map((master) => {
            return {
              value: master.id,
              text: master.name,
              type: master.type,
              name: master.name,
              contact: master.contact,
            };
          });

          this.filterItems = this.tableData;
          this.selectAll = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 削除
    deleteItems() {
      this.loading = true;
      let list = this.tableData.filter((item) => item.selected);
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
      });
      console.log("ids:", ids);
      axios
        .post("/api/staff/delete", {
          ids: ids,
        })
        .then((response) => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 追加
    add() {
      this.mode = "add";
      this.id = "new";
      this.game_id = this.search_game_id;
      this.school_code = this.search_school_code;
      this.type = ""; // Initialize type explicitly
      this.name = ""; // 新しい氏名フィールドを追加
      this.contact = ""; // 新しい連絡先フィールドを追加
    },
    // 編集
    edit(item) {
      this.mode = "edit";
      this.id = item.id;
      this.game_id = item.game_id;
      this.school_code = item.school_code;
      this.type = item.type;
      this.$nextTick(() => {
        // typeの変更後に氏名を設定
        this.name = item.name;
        this.contact = item.contact;
      });
    },
    // 確定
    submit() {
      let formData = new FormData();

      // 必要な値を追加
      formData.append("id", this.id);
      formData.append("game_id", this.game_id || ""); // 空文字列を送信
      formData.append("school_code", this.school_code || ""); // 空文字列を送信
      formData.append("type", this.type || ""); // 分類フィールド
      formData.append("name", this.name || ""); // 氏名フィールド
      formData.append("contact", this.contact || ""); // 連絡先フィールド

      console.log("formData:", Array.from(formData.entries()));

      // StaffMastersに存在しない場合、新規登録
      const isNameInMasters = this.staffMasters.some(
        (master) => master.name === this.name && master.type === this.type
      );
      if (!isNameInMasters) {
        this.loading = true;
        axios
          .post("/api/staff/add-master", {
            type: this.type,
            name: this.name,
            contact: this.contact,
          })
          .then((response) => {
            this.loading = false;
            this.finalizeSubmit(formData);
          })
          .catch((error) => {
            this.loading = false;
            this.errorProcess(error);
          });
      } else {
        this.finalizeSubmit(formData);
      }
    },

    finalizeSubmit(formData) {
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      this.loading = true;
      axios
        .post("/api/staff/update", formData, config)
        .then((res) => {
          this.loading = false;
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onFiltered(items) {
      this.filterItems = items;
    },
    formatDate(date) {
      if (!date) return ""; // nullまたはundefinedの場合は空欄を返す
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date).toLocaleDateString("ja-JP", options);
    },
    exportStaff() {
      let params = {
        game_id: this.search_game_id || null,
      };
      // ユーザーの場合は school_code を必ず指定
      if (this.$store.getters.roles === "user") {
        params.school_code = this.search_school_code || this.school_code || null;
      }
      axios
        .get("/api/staff/export/list", {
          params: params,
          responseType: "blob",
        })
        .then((response) => {
          let fileName = "顧問・コーチ一覧.xlsx";
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.errorProcess(error);
        });
    },
    goToGameInfo() {
      window.location.href = `/game-info`;
    },
    onNameSelect(selected) {
      if (!selected) {
        this.name = "";
        this.contact = "";
        return;
      }

      if (typeof selected === "string") {
        // 新しい値が入力された場合
        this.name = selected;
      } else if (typeof selected === "object") {
        // オブジェクトの場合
        this.name = selected.text;
        this.contact = selected.contact || "";
      }
    },
    deleteStaffMaster() {
      console.log("Deleting staff master:", this.name, this.type);
      // 氏名が未選択または空白の場合は処理を中止
      if (!this.name) return;

      const master = this.staffMasters.find(
        (master) => master.name === this.name && (master.type || '') === (this.type || '')
      );

      if (!master) return;

      // APIリクエストで削除
      this.loading = true;
      axios
        .post("/api/staff/delete-master", { id: master.value })
        .then(() => {
          const index = this.staffMasters.findIndex(
            (m) => m.value === master.value
          );
          if (index !== -1) {
            this.staffMasters.splice(index, 1);
            this.name = "";
            this.contact = "";
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
  },
  watch: {
    selectAll(newValue) {
      this.filterItems.forEach((item) => {
        item.selected = this.selectAll;
      });
    },
    type(newVal, oldVal) {
      // タイプが変更されたら氏名を空にする
      this.name = "";
      this.contact = "";
    },
  },
};
</script>

<style>
.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}

.minWidth150 {
  min-width: 150px;
  word-break: break-all;
}

.minWidth300 {
  min-width: 300px;
  word-break: break-all;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- リスト -->
    <div class="row" v-if="mode == 'list'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2 me-2">
              <div class="col-sm-12 col-md-6">
                <b-form-group label="大会" label-cols-sm="3">
                  <b-form-select v-model="search_game_id" :options="games" @change="searchItems" class="form-select"
                    disabled></b-form-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-3">
                <b-form-group label="学校" label-cols-sm="3">
                  <b-form-select v-model="search_school_code" :options="schoolList" @change="searchItems"
                    class="form-select" :disabled="$store.getters.roles === 'user'"></b-form-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-3">
                <b-form-group label="分類" label-cols-sm="3">
                  <b-form-select v-model="search_type" :options="typeList" @change="searchItems"
                    class="form-select"></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <label class="ms-1 mb-0 pb-0">件数：{{ filterItems.length }}</label>
            </div>
            <hr class="mt-1 pt-0" />
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    表示&nbsp;
                    <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                      :options="pageOptions"></b-form-select>&nbsp;行
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="text-md-end">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    フィルタ:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <b-table striped hover :items="tableData" :fields="displayedFields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template v-slot:head(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="selectAll">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="item.selected" class="mr-1">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(actions)="{ item }">
                  <span>
                    <button class="btn btn-sm btn-outline-primary" @click="edit(item)">
                      編集
                    </button>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-12 mb-3">
                <div id="tickets-table_filter" class="text-md-end">
                  <button class="btn btn-danger me-2" type="button" v-b-modal.modal-delete>
                    削除
                  </button>
                  <button class="btn btn-primary me-2" type="button" @click="add">
                    追加
                  </button>
                  <button class="btn btn-success me-2" @click="exportStaff">リスト出力</button>
                  <button class="btn btn-primary" @click="goToGameInfo">戻る</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- 追加・編集 -->
    <div class="row" v-if="mode == 'add' || mode == 'edit'">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              {{ mode == "add" ? "新規登録" : "編集" }}
            </h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group label="大会" label-cols-sm="3">
                      <ValidationProvider name="大会" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-select plain v-model="game_id" :options="games" disabled></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="学校コード" label-cols-sm="3">
                      <ValidationProvider name="学校コード" :rules="{ required: false }">
                        <div slot-scope="ProviderProps">
                          <b-form-select v-model="school_code" :options="schoolList" placeholder="学校を選択"
                            class="form-select" style="width: 200px"
                            :disabled="$store.getters.roles === 'user'"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="分類" label-cols-sm="3">
                      <ValidationProvider name="分類" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-select v-model="type" :options="typeList" class="form-select"
                            style="width: 200px"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="氏名" label-cols-sm="3">
                      <ValidationProvider name="氏名" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <div class="d-flex align-items-center">
                            <v-select v-model="name"
                              :options="staffMasters.filter(master => (master.type || '') === (type || ''))"
                              label="text" :taggable="true" style="width: 300px" @input="onNameSelect"></v-select>
                            <b-button variant="danger" size="sm" class="ms-2" @click="deleteStaffMaster"
                              :disabled="!name">
                              削除
                            </b-button>
                          </div>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="連絡先" label-cols-sm="3">
                      <ValidationProvider name="連絡先" :rules="{ required: false }">
                        <div slot-scope="ProviderProps">
                          <b-form-input v-model="contact" class="form-control" style="width: 300px"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                      @click="submit">確定</b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- 削除 -->
    <b-modal id="modal-delete" title="確認" title-class="font-18" @ok="deleteItems">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>
